import React, { useEffect, useState, useContext } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import './index.css';
import { api } from '../../services/api';
import Loading from "../../comum/Layout/loading.jsx";
import Menu from '../../comum/Menu/menu.jsx';
import Footer from '../../comum/Footer/index.jsx';


function Avaliacao() {
    const [codigorest, setCodigoRest] = useState(0);
    const [tabelas, setTabelas] = useState([]);
    const [removeLoading, setRemoveLoading] = useState(false);
    const navigate = useNavigate()

    useEffect(() => {
        const codigorest = localStorage.getItem("codigorest");
        if (!codigorest) {
            navigate("/restaurante/login"); // Redireciona se não for funcionário logado
        }
    }, []);

    function formatLeadingZero(text) {
        {/*return (parseInt(text) < 10 ? `00${text}` : (parseInt(text) < 100) ?  `0${text}` :  `${text}`));*/ }
        if (parseInt(text) < 10) {
            return `00${text}`;
        } else if (parseInt(text) < 100) {
            return `0${text}`;
        } else {
            return `${text}`;
        }
    }

    function GeraEstrela(numero) {
        if (numero === 5) {
            return <div >
                <ul className="list-unstyled list-inline social text-center">
                    <li className="list-inline-item "><i className="fa fa-star fa-1x cor-av"></i></li>
                    <li className="list-inline-item "><i className="fa fa-star fa-1x cor-av"></i></li>
                    <li className="list-inline-item "><i className="fa fa-star fa-1x cor-av"></i></li>
                    <li className="list-inline-item "><i className="fa fa-star fa-1x cor-av"></i></li>
                    <li className="list-inline-item "><i className="fa fa-star fa-1x cor-av"></i></li>
                </ul>
            </div>;
        } else if (numero === 4) {
            return <div >
                <ul className="list-unstyled list-inline social text-center">
                    <li className="list-inline-item "><i className="fa fa-star fa-1x cor-av"></i></li>
                    <li className="list-inline-item "><i className="fa fa-star fa-1x cor-av"></i></li>
                    <li className="list-inline-item "><i className="fa fa-star fa-1x cor-av"></i></li>
                    <li className="list-inline-item "><i className="fa fa-star fa-1x cor-av"></i></li>
                    <li className="list-inline-item "><i className="fa fa-star fa-1x cor-notav"></i></li>
                </ul>
            </div>;
        } else if (numero === 3) {
            return <div >
                <ul className="list-unstyled list-inline social text-center">
                    <li className="list-inline-item "><i className="fa fa-star fa-1x cor-av"></i></li>
                    <li className="list-inline-item "><i className="fa fa-star fa-1x cor-av"></i></li>
                    <li className="list-inline-item "><i className="fa fa-star fa-1x cor-av"></i></li>
                    <li className="list-inline-item "><i className="fa fa-star fa-1x cor-notav"></i></li>
                    <li className="list-inline-item "><i className="fa fa-star fa-1x cor-notav"></i></li>
                </ul>
            </div>;
        } else if (numero === 2) {
            return <div >
                <ul className="list-unstyled list-inline social text-center">
                    <li className="list-inline-item "><i className="fa fa-star fa-1x cor-av"></i></li>
                    <li className="list-inline-item "><i className="fa fa-star fa-1x cor-av"></i></li>
                    <li className="list-inline-item "><i className="fa fa-star fa-1x cor-notav"></i></li>
                    <li className="list-inline-item "><i className="fa fa-star fa-1x cor-notav"></i></li>
                    <li className="list-inline-item "><i className="fa fa-star fa-1x cor-notav"></i></li>
                </ul>
            </div>;
        } else if (numero === 1) {
            return <div >
                <ul className="list-unstyled list-inline social text-center">
                    <li className="list-inline-item "><i className="fa fa-star fa-1x cor-av"></i></li>
                    <li className="list-inline-item "><i className="fa fa-star fa-1x cor-notav"></i></li>
                    <li className="list-inline-item "><i className="fa fa-star fa-1x cor-notav"></i></li>
                    <li className="list-inline-item "><i className="fa fa-star fa-1x cor-notav"></i></li>
                    <li className="list-inline-item "><i className="fa fa-star fa-1x cor-notav"></i></li>
                </ul>
            </div>;
        }
    }

    useEffect(() => {
        setCodigoRest(localStorage.getItem("codigorest"));
        console.log(localStorage.getItem("codigorest"));
        api.get('/restaurante/avaliacao/' + localStorage.getItem("codigorest"))
            .then(response => {
                setTabelas(response.data);
                console.log(response.data);
                setRemoveLoading(true);
            })
            .catch(err => {
                console.log(err.data);
                return null;
            });
    }, []);




    return <div>
        <Menu modulo="REST" />
        <div className="container-fluid titulo">
            {!removeLoading && <Loading />}
            <h3>Avaliações dos últimos 30 dias<p></p></h3>

            <table className="table table-hover table-bordered">
                <thead>
                    <tr className="table-secondary" align='center'>
                        <th scope="col" width="10">Loja</th>
                        <th scope="col" width="30">Data Hora</th>
                        <th scope="col">Avaliação</th>
                    </tr>
                </thead>
                <tbody>

                    {
                        tabelas.map((av, index) => {
                            return  <tr className="tb" key={`${av.loja}-${av.data}-${av.hora}-${index}`}>
                                <td className="tb" scope="row" align='center'>{formatLeadingZero(av.loja)} </td>
                                <td className="tb" align='center'>{av.data}<p>{av.hora}</p></td>
                                <td className="tb">{GeraEstrela(av.av)}{av.comentario}</td>
                            </tr>
                        })
                    }

                </tbody>
            </table>
        </div>
        {removeLoading && <Footer className="footer navbar-fixed-bottom" />}

    </div>

}

export default Avaliacao;